import Support from '../../view-stack/utils/support';

export default function install() {
  Support('conversation', {
    request: id => `/api/conversation/${id}`,
    data: 'conversation',
    components: {
      default: () => import('./Conversation.vue'),
      header: () => import('./Header.vue'),
    },
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin/conversation/index.js